import { useContext, useEffect, useState } from "react";
// components
// styled components
import { Empty, Table, Modal, Tooltip } from "antd";
import { Dropdown, Icon, Button } from "semantic-ui-react";
// hooks
import { useMisPostulaciones } from "../../../hooks/useMisPostulaciones";
// icons
import {
  AppstoreOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  ExclamationCircleFilled,
  InfoCircleOutlined,
  BarChartOutlined,
  TrophyOutlined,
  StopOutlined,
} from "@ant-design/icons";
// data select
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";
import { openNotification } from "../../../utils/Notifactions";
// another components
// import { ModalVerPropuesta } from "../../Admin/Convocatorias/GestionarPostulaciones/components/ModalVerPropuesta";
import { ModalVerPropuesta } from "./components/ModalVerPropuesta";
import { ModalVerPropuesta as ModalVerPropuestaSubsanar } from "./components/ModalVerPropuestaSubsanar";
import { VerMasProyectos } from "../../Admin/SeguimientoProyectos/VerMasProyectos";
import { TemplateContext } from "../../../utils/template_context";
import { ObjNotificaciones } from "../../../config/notificaciones";
import { useEncrypt } from "../../../hooks/useEncrypt";
import { useNavigate } from "react-router-dom";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import moment from "moment";
import { ModalAvisoInfo } from "../../Landing/components/ModalAvisoInfo";
import getStorageUser from "../../../middlewares/GetStorageUser";
import { itemRenderTable } from "../../../utils/itemRenderTable";
import {
  estadoDeLosPasos,
  pasosCompletados,
  rutaDelPaso,
} from "../Postulacion/pasosPostulacion";

import { fechaCierre, momentCierre } from '../../../utils/horaCierre';
import { convocatoriaCerrada } from '../../../utils/puedeInscribirse';
import { finPlazoSubsanar, plazoSubsanarVencido } from '../../../utils/subsanacion';
import { CampoDeBusqueda } from "../../../components/Generales/CampoDeBusqueda";
import { filtrarPostulaciones } from "../../../utils/busquedaPostulaciones";


// colors state of postulation
const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
  "Por completar": "#F28C02",
  "Anulado": "#0051E6"
};
// indetification types
const TiposIdentificacion: any = {
  "1": "Persona Natural",
  "3": "Grupo Conformado",
  "2": "Persona Jurídica",
};

export const Mispostulaciones = () => {
  const user = getStorageUser() || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [modalSubsanar, setModalSubsanar] = useState(false);
  const [postulacionSubsanar, setPostulacionSubsanar] = useState<any>(null);

  const abrirSubsanar = (item: any) => {
    setPostulacionSubsanar(item);
    setModalSubsanar(true);
  };

  const [verMasOpen, setVerMasOpen] = useState(false);
  const [datosEvaluacion, setDatosEvaluacion] = useState<any>(null);

  const verResultadosEvaluacion = (item: any) => {
    const datosFormateados = {
      ...item,
      postulacion: item?.postulacion || item,
    };
    setDatosEvaluacion(datosFormateados);
    setVerMasOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk2 = () => {
    setIsModalOpen2(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };


  const {
    postulaciones,
    setPostulaciones,
    cargarPostulaciones,
    totalregistros,
    setTotalregistros,
    cantidadpáginas,
    cambiarCantidadPaginas,
    modal,
    setModal,
    descargarArchivo,
    obtenerLineasConvocatorias,
    lineasconvocatoria,
    postulacion,
    verPropuesta,
    datosFiltrados,
    setDatosFiltrados,
  } = useMisPostulaciones();

  useEffect(() => {
    localStorage.removeItem("id_postulacion");
    localStorage.removeItem("idConvocatoriaPostulacion");
    localStorage.removeItem("tipo_participante_postulacion");
    cargarPostulaciones();
    obtenerLineasConvocatorias();
  }, []);

  const [avisoInfo, setAvisoInfo] = useState<boolean>(false);

  interface PostulacionModel {
    id_postulacion: number;
    convocatoria_id: number;
    numero_documento_participante: number;
    nombre_propuesta: string;
    nombre_participante: string;
    jurados: Array<Object>;
    estado_jurado: boolean;
    fecha_creacion: string;
    tipo_participante: string;
    links: Array<Object>;
    nombre_convocatoria: string;
    categoria_linea_convocatoria: Array<Object>;
    fecha_apertura: string;
    fecha_actualizacion: string;
    particiapnte: Array<Object>;
    estado: string;
    documentos_generales: Array<Object>;
    documentos_tecnicos: Array<any>;
    documentos_administrativos: any;
    linea_convocatoria: number;
    radicado: string;
    pasos: {
      personales: boolean,
      categorias: boolean,
      administrativos: boolean,
      tecnicos: boolean,
      links: boolean
    };
  }

  const initialValuesPostulacionModel = {
    id_postulacion: 0,
    convocatoria_id: 0,
    numero_documento_participante: 0,
    nombre_propuesta: "",
    nombre_participante: "",
    jurados: [],
    estado_jurado: false,
    fecha_creacion: "",
    tipo_participante: "",
    links: [],
    nombre_convocatoria: "",
    categoria_linea_convocatoria: [],
    fecha_apertura: "",
    fecha_actualizacion: "",
    particiapnte: [],
    estado: "",
    documentos_generales: [],
    documentos_tecnicos: [],
    documentos_administrativos: [],
    linea_convocatoria: 0,
    radicado: "",
    pasos: {
      personales: true,
      categorias: false,
      administrativos: false,
      tecnicos: false,
      links: false
    }
  };

  const { encrypt } = useEncrypt();
  const navigate = useNavigate();
  const [postulacionEditar, setPostulacionEditar] = useState<PostulacionModel>(initialValuesPostulacionModel);

  const guardar = async (datos?: any) => {
    try {
      await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: datos.id_postulacion, estado: "Anulado" });
    } catch (error) {
      console.log(error)
    }
    window.location.reload();
  }

  const validateFormsCompleted = (datos) => {
    datos.pasos = pasosCompletados(datos);
    localStorage.setItem('id_postulacion', encrypt(datos.id_postulacion.toString()));
    if (!localStorage.getItem('idConvocatoriaPostulacion')) {
      localStorage.setItem('idConvocatoriaPostulacion', encrypt(datos.convocatoria_id.toString()))
    }
    if (!localStorage.getItem("tipo_participante_postulacion")) {
      localStorage.setItem("tipo_participante_postulacion", `${datos.tipo_participante - 1}`);
    }
    //Se resta uno debido a que los documentos evaluan a los tipos de participantes del 0 al 2 y no del 1 al 3 como al momento del registro
    setPostulacionEditar(datos);
  }

  // pagination table

  const context = useContext(TemplateContext);
  // columns postulation
  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
            <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Nombre de proyecto",
      width: 300,
      fixed: context.device === "md" ? "left" : false,
      render: (data: any) =>
        <span style={{ whiteSpace: "pre-line" }}>
          {data?.nombre_propuesta}
        </span>,
    },
    {
      title: "Código",
      width: 80,
      render: (data: any) => <span>{data?.radicado}</span>,
    },
    {
      title: "Estado",
      key: "estado",
      width: 175,
      render: (data: any) => {
        const estadoNorm = (data?.estado || "").toLowerCase().trim();
        const esSubEstado = estadoNorm === "subsanar" || estadoNorm === "por subsanar";
        // Si el plazo de subsanación ya venció, no se puede subsanar: se muestra
        // como "No subsanado" y sin el botón, para no llevar al usuario al error.
        const esSubVencido = esSubEstado && plazoSubsanarVencido(data);
        const esSub = esSubEstado && !esSubVencido;
        const tieneNota = data?.nota_final !== undefined && data?.nota_final !== null && data?.nota_final !== "";
        const esEval = ["evaluado", "evaluada"].includes(estadoNorm) || tieneNota;

        return (
          <div className="d-flex flex-column align-items-start" style={{ maxWidth: "100%" }}>
            <span style={{ color: esSubVencido ? "#cf1322" : (coloresEstado[data?.estado] || (esSub ? "#F28C02" : "black")), fontWeight: esSub || esEval || esSubVencido ? 600 : "normal" }}>
              {esSubVencido ? "No subsanado" : (data?.estado == 'Sin revisar' ? 'Inscrito sin revisar' : data?.estado)}
            </span>
            {esSubVencido && (
              <span style={{ fontSize: "11px", color: "#8c8c8c", marginTop: "2px", display: "block", whiteSpace: "normal", wordBreak: "break-word", lineHeight: 1.3 }}>
                {textoPlazoSubsanarVencido(data)}
              </span>
            )}
            {esSub && (
              <button
                type="button"
                className="btn btn-sm mt-1"
                style={{
                  backgroundColor: "#F28C02",
                  color: "#fff",
                  fontSize: "11px",
                  padding: "2px 10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
                onClick={() => abrirSubsanar(data)}
              >
                <span>✏️</span> Subsanar
              </button>
            )}
            {esEval && (
              <div className="d-flex flex-column align-items-start mt-1">
                {tieneNota && (
                  <span
                    style={{
                      backgroundColor: "#f0fdf4",
                      color: "#16a34a",
                      border: "1px solid #bbf7d0",
                      fontSize: "11px",
                      fontWeight: 700,
                      padding: "1px 8px",
                      borderRadius: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "3px",
                      marginBottom: "2px",
                    }}
                  >
                    <span>📊</span> {data.nota_final} pts
                  </span>
                )}
                <button
                  type="button"
                  className="btn btn-link p-0"
                  style={{
                    fontSize: "11px",
                    color: "#1e3a8a",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontFamily: "Montserrat-SemiBold",
                  }}
                  onClick={() => verResultadosEvaluacion(data)}
                >
                  Ver más
                </button>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Linea convocatoria",
      ellipsis: true,
      width: 300,
      render: (data: any) => {
        return <span style={{ whiteSpace: "pre-line" }}>{data?.linea_convocatoria}</span>;
      },
    },
    {
      title: "Categoría",
      width: 150,
      render: (datos: any) => {
        return (
            <span style={{ whiteSpace: "pre-line" }}>{datos.categoria_linea_convocatoria}</span>
        );
      },
    },
    {
      title: "Tipo participante",
      // width: 140,
      render: (datos: any) => {
        return (
            <span>{TiposIdentificacion[datos.tipo_participante]}</span>
        );
      },
    },
    {
      title: "Fecha de creación",
      width: 130,
      render: (data: any) => (
        <span>{data?.fecha_creacion ? moment(data.fecha_creacion).format("DD/MM/YYYY") : ""}</span>
      ),
    },
    {
      title: () => (
        <div className="titleAcciones" style={{ marginBottom: 0 }}>
          Acciones
        </div>
      ),
      width: 175,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => {
        /*
          El lapiz de editar solo se muestra si la propuesta es editable (borrador / por completar)
          O rol de administrador, Y la convocatoria sigue abierta.
        */
        const estadoNorm = (datos?.estado || "").toLowerCase().trim();
        // Si el plazo de subsanación venció ya no se ofrece la acción de subsanar.
        const esSubsanar = (estadoNorm === "subsanar" || estadoNorm === "por subsanar") && !plazoSubsanarVencido(datos);
        const tieneNota = datos?.nota_final !== undefined && datos?.nota_final !== null && datos?.nota_final !== "";
        const esEvaluada = ["evaluado", "evaluada"].includes(estadoNorm) || tieneNota;
        const esBorrador = ["Por completar", "Por guardar", "Borrador"].includes(datos?.estado);
        const esAdmin = Boolean(user && user.role_id == 1);

        let convocatoriaAbierta = true;
        if (datos?.convocatoria_cerrada !== undefined) {
          convocatoriaAbierta = !datos.convocatoria_cerrada;
        } else if (datos?.fecha_cierre) {
          convocatoriaAbierta = moment().isBefore(moment(fechaCierre(datos.fecha_cierre)));
        } else if (Array.isArray(datos?.fechas) && datos.fechas.length > 0) {
          convocatoriaAbierta = !convocatoriaCerrada(datos);
        }

        const puedeEditar = (esAdmin || esBorrador) && convocatoriaAbierta;

        /*
          Y una sola papelera, que salia por tres caminos. La linea de Banco de
          artistas se anula sin mirar el cierre porque su cronograma no trae esa
          fecha: con la comprobacion de los demas, el boton no haria nada.
        */
        const esDeBancoDeArtistas = datos?.linea_convocatoria === "Banco de artistas - PP";
        const seAnulaMirandoElCierre = ["Sin revisar", "Inscrito sin revisar"].includes(
          datos?.estado
        );
        const puedeAnular = seAnulaMirandoElCierre || esDeBancoDeArtistas;

        /**
         * Despues del cierre no se anula. Lo comprueba contra la fecha de la
         * convocatoria, que se pide en el momento y no se toma de lo cargado.
         */
        const anular = async () => {
          if (seAnulaMirandoElCierre) {
            const convocatoria = await apiConvocatorias.getConvocatoriaById(
              datos.convocatoria_id
            );

            for (const element of convocatoria.data.fechas) {
              if (element.clave == "Cierre") {
                const fechaActual = moment();
                const cierreAct = fechaCierre(element.valormax);

                if (fechaActual.isBefore(moment(cierreAct))) {
                  showModal2();
                  validateFormsCompleted(datos);
                } else {
                  return openNotification({
                    titulo: "Error",
                    descripcion: `No es permitido anular una propuesta después del cierre de la convocatoria`,
                    placement: "bottomRight",
                  });
                }
              }
            }
            return;
          }

          showModal2();
          validateFormsCompleted(datos);
        };

        return (
          <div className="controls" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", flexWrap: "nowrap" }}>
            <Tooltip title="Ver propuesta" placement="top">
              <span style={{ display: "inline-flex" }}>
                <Button
                  onClick={() => verPropuesta(datos)}
                  className="botones-acciones"
                  icon={<Icon name="eye" style={{ cursor: "pointer" }} />}
                />
              </span>
            </Tooltip>
            {puedeEditar && (
              <Tooltip title="Editar propuesta" placement="top">
                <span style={{ display: "inline-flex" }}>
                  <Button
                    onClick={() => {
                      showModal();
                      validateFormsCompleted(datos);
                    }}
                    className="button-ant-ant"
                    icon={<Icon name="pencil" style={{ cursor: "pointer" }} />}
                  />
                </span>
              </Tooltip>
            )}
            {esSubsanar && (
              <Tooltip title="Subsanar documentos" placement="top">
                <span style={{ display: "inline-flex" }}>
                  <Button
                    onClick={() => abrirSubsanar(datos)}
                    className="botones-acciones boton-subsanar-accion"
                    icon={<Icon name="file alternate" />}
                  />
                </span>
              </Tooltip>
            )}
            {esEvaluada && (
              <Tooltip
                title={
                  tieneNota
                    ? `Ver evaluación (Puntaje: ${datos.nota_final} pts)`
                    : "Ver resultados de evaluación"
                }
                placement="top"
              >
                <span style={{ display: "inline-flex" }}>
                  <Button
                    onClick={() => verResultadosEvaluacion(datos)}
                    className="botones-acciones boton-evaluacion-accion"
                    icon={<Icon name="chart bar" style={{ cursor: "pointer" }} />}
                  />
                </span>
              </Tooltip>
            )}
            {puedeAnular && (
              <Tooltip title="Anular propuesta" placement="top">
                <span style={{ display: "inline-flex" }}>
                  <Button
                    onClick={anular}
                    className="botones-acciones boton-borrar-adminconvocatorias"
                    icon={<Icon name="trash alternate outline" style={{ cursor: "pointer" }} />}
                  />
                </span>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];
  const [kpiSeleccionado, setKpiSeleccionado] = useState<string | null>(null);

  const primerNombre = user?.nombres
    ? user.nombres.split(" ")[0].charAt(0).toUpperCase() + user.nombres.split(" ")[0].slice(1).toLowerCase()
    : "Laura";

  const getMissingText = (item: any) => {
    if ((item?.estado || "").toLowerCase().trim() === "subsanar") {
      return "Documentos por subsanar";
    }
    if (item?.pasos) {
      if (!item.pasos.personales) return "Información personal";
      if (!item.pasos.categorias) return "Categoría de la propuesta";
      if (!item.pasos.administrativos) return "Documentos administrativos";
      if (!item.pasos.tecnicos) return "Muestra de trabajo o portafolio";
      if (!item.pasos.links) return "Enlaces y documentos finales";
    }
    return "Documentos pendientes";
  };

  /**
   * Si la convocatoria sigue abierta. Repite la regla que ya se usa arriba para
   * habilitar el botón: primero el dato explícito, luego la fecha de cierre
   * (con su hora real) y, si solo hay cronograma, el cálculo por fechas.
   */
  const convocatoriaAbiertaItem = (item: any): boolean => {
    if (item?.convocatoria_cerrada !== undefined) return !item.convocatoria_cerrada;
    if (item?.fecha_cierre) return moment().isBefore(momentCierre(item.fecha_cierre));
    if (Array.isArray(item?.fechas) && item.fechas.length > 0) return !convocatoriaCerrada(item);
    return true;
  };

  const esPendiente = (item: any) => {
    if (!item) return false;
    const estado = (item?.estado || "").toLowerCase().trim();

    // Subsanar es un trámite posterior al cierre, así que se mantiene aunque la
    // convocatoria ya haya cerrado, pero solo mientras el plazo de subsanación
    // siga vigente. Si ya venció no hay nada que el usuario pueda hacer.
    if (estado === "subsanar") return !plazoSubsanarVencido(item);

    // Si ya cerró, no hay nada que "continuar": la postulación no se puede
    // completar, así que no es una acción pendiente.
    if (!convocatoriaAbiertaItem(item)) return false;

    if (["por completar", "por guardar", "borrador"].includes(estado)) {
      return true;
    }
    if (item?.pasos && (!item.pasos.links || !item.pasos.tecnicos || !item.pasos.administrativos)) {
      return true;
    }
    return false;
  };

  const MESES = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ];

  /** Texto del aviso cuando el plazo de subsanación ya pasó. */
  const textoPlazoSubsanarVencido = (item: any): string => {
    const fin = finPlazoSubsanar(item);
    if (!fin) return "El plazo de subsanación ya venció";
    return `El plazo de subsanación venció el ${fin.date()} ${MESES[fin.month()]} ${fin.year()}`;
  };

  /** La fecha de cierre con su hora real, p. ej. "21 octubre 2026, 11:59 p. m.". */
  const getFechaCierreDisplay = (item: any) => {
    const valor = item?.fecha_cierre || item?.fecha_actualizacion;
    if (!valor) return "6 julio 2026";
    const m = momentCierre(valor);
    if (!m.isValid()) return String(valor);
    const fecha = `${m.date()} ${MESES[m.month()]} ${m.year()}`;
    const hora = `${m.format("h:mm")} ${m.hours() < 12 ? "a. m." : "p. m."}`;
    return `${fecha}, ${hora}`;
  };

  const matchesKpi = (item: any, kpiKey: string): boolean => {
    const est = (item?.estado || "").toLowerCase().trim();
    switch (kpiKey) {
      case "completar":
      case "por_completar":
      case "guardar":
      case "por_guardar":
        return (
          ["por completar", "por guardar", "borrador"].includes(est) ||
          (est === "" && item?.pasos && (!item.pasos.links || !item.pasos.tecnicos || !item.pasos.administrativos))
        );
      case "inscritas":
        return [
          "sin revisar",
          "inscrito",
          "inscrita",
          "inscrito sin revisar",
          "aceptado",
        ].includes(est);
      case "subsanar":
        return ["subsanar", "por subsanar"].includes(est) && !plazoSubsanarVencido(item);
      case "no_subsanado":
        return ["subsanar", "por subsanar"].includes(est) && plazoSubsanarVencido(item);
      case "anuladas":
        return ["anulado", "anulada"].includes(est);
      case "evaluadas":
        return [
          "evaluado",
          "evaluada",
          "en evaluacion",
          "en evaluación",
          "evaluación",
        ].includes(est);
      case "rechazadas":
        return ["rechazado", "rechazada"].includes(est);
      case "beneficiario":
        return [
          "beneficiario",
          "beneficiaria",
          "ganador",
          "ganadora",
          "otorgado",
          "seleccionado",
        ].includes(est);
      case "todas":
        return true;
      default:
        return true;
    }
  };

  const toggleKpi = (key: string) => {
    if (kpiSeleccionado === key || key === "todas") {
      setKpiSeleccionado(null);
    } else {
      setKpiSeleccionado(key);
    }
  };

  const getKpiLabel = (key: string) => {
    switch ((key || "").toLowerCase().trim()) {
      case "completar":
      case "por_completar":
      case "guardar":
      case "por_guardar":
        return "Por completar";
      case "inscritas":
        return "Inscritas";
      case "subsanar":
        return "Por subsanar";
      case "no_subsanado":
        return "No subsanado";
      case "evaluadas":
        return "Evaluadas";
      case "rechazadas":
        return "Rechazadas";
      case "anuladas":
        return "Anuladas";
      case "beneficiario":
        return "Beneficiario";
      default:
        return key.toUpperCase();
    }
  };

  const countTodas = postulaciones.length;
  const countCompletar = postulaciones.filter((p: any) => matchesKpi(p, "completar")).length;
  const countInscritas = postulaciones.filter((p: any) => matchesKpi(p, "inscritas")).length;
  const countSubsanar = postulaciones.filter((p: any) => matchesKpi(p, "subsanar")).length;
  const countNoSubsanado = postulaciones.filter((p: any) => matchesKpi(p, "no_subsanado")).length;
  const countEvaluadas = postulaciones.filter((p: any) => matchesKpi(p, "evaluadas")).length;
  const countRechazadas = postulaciones.filter((p: any) => matchesKpi(p, "rechazadas")).length;
  const countAnuladas = postulaciones.filter((p: any) => matchesKpi(p, "anuladas")).length;
  const countBeneficiario = postulaciones.filter((p: any) => matchesKpi(p, "beneficiario")).length;

  useEffect(() => {
    if (kpiSeleccionado && kpiSeleccionado !== "todas") {
      const counts: Record<string, number> = {
        completar: countCompletar,
        inscritas: countInscritas,
        subsanar: countSubsanar,
        no_subsanado: countNoSubsanado,
        evaluadas: countEvaluadas,
        rechazadas: countRechazadas,
        anuladas: countAnuladas,
        beneficiario: countBeneficiario,
      };
      if ((counts[kpiSeleccionado] ?? 0) === 0) {
        setKpiSeleccionado(null);
      }
    }
  }, [
    kpiSeleccionado,
    countCompletar,
    countInscritas,
    countSubsanar,
    countNoSubsanado,
    countEvaluadas,
    countRechazadas,
    countAnuladas,
    countBeneficiario,
  ]);

  const pendingItem = postulaciones.find((p: any) => esPendiente(p));

  const listaFiltradaPorTexto = datosFiltrados && datosFiltrados.length > 0 ? datosFiltrados : postulaciones;
  const datosAMostrar = kpiSeleccionado && kpiSeleccionado !== "todas"
    ? listaFiltradaPorTexto.filter((p: any) => matchesKpi(p, kpiSeleccionado))
    : listaFiltradaPorTexto;

  const buscar = (texto: string) => {
    const encontradas = filtrarPostulaciones(postulaciones, texto);
    setDatosFiltrados(encontradas);
    setTotalregistros(encontradas.length);
  };

  return (
    <div className="mis-postulaciones-container">
      {/* 1. Saludo y bienvenida */}
      <div className="mis-postulaciones-header-section mb-3">
        <h1 className="mis-postulaciones-greeting-title">Hola, {primerNombre}</h1>
        <p className="mis-postulaciones-greeting-subtitle">
          Aquí puedes consultar tus postulaciones, descubrir nuevas convocatorias y revisar lo que tienes pendiente.
        </p>
      </div>

      {/* 2. Alerta de acción pendiente */}
      {pendingItem && (
        <div className="card-pending-action mb-4">
          <div className="card-pending-action-content">
            <div className="card-pending-action-icon">
              <ExclamationCircleFilled style={{ fontSize: 22, color: "#d97706" }} />
            </div>
            <div className="card-pending-action-text">
              <div className="card-pending-action-heading">Tienes una acción pendiente</div>
              <div className="card-pending-action-convocatoria">
                {pendingItem.nombre_convocatoria || pendingItem.linea_convocatoria || pendingItem.nombre_propuesta}
              </div>
              <div className="card-pending-action-details">
                Falta: <strong>{getMissingText(pendingItem)}</strong> · Cierre: <strong>{getFechaCierreDisplay(pendingItem)}</strong>
              </div>
            </div>
          </div>
          <div className="card-pending-action-btn-wrap">
            <button
              type="button"
              className="btn-continuar-postulacion"
              onClick={() => {
                if ((pendingItem?.estado || "").toLowerCase().trim() === "subsanar") {
                  abrirSubsanar(pendingItem);
                } else {
                  validateFormsCompleted(pendingItem);
                  showModal();
                }
              }}
            >
              {(pendingItem?.estado || "").toLowerCase().trim() === "subsanar"
                ? "Subsanar documentos"
                : "Continuar postulación"}
            </button>
          </div>
        </div>
      )}

      {/* 3. KPIs de resumen y filtros interactivos (ordenados inteligentemente por urgencia y estado) */}
      {countTodas > 0 && (
        <div className="kpis-cards-wrapper">
          {/* 1. Todas las postulaciones */}
          <div className="kpi-col-item">
            <div
              className={`kpi-card kpi-card-todas kpi-card-clickable ${!kpiSeleccionado || kpiSeleccionado === "todas" ? "kpi-card-selected" : ""}`}
              onClick={() => setKpiSeleccionado(null)}
              role="button"
              tabIndex={0}
              title="Ver todas las postulaciones"
            >
              <div className="kpi-icon-badge">
                <AppstoreOutlined />
              </div>
              <div className="kpi-value">{countTodas}</div>
              <div className="kpi-label">Todas</div>
            </div>
          </div>

          {/* Orden por escala de color: cálidos (naranja/ámbar) → rojos juntos →
              fríos (azul/violeta/verde) → neutro (gris). */}

          {/* 2. Por subsanar (naranja) — Prioridad 1: acción urgente */}
          {countSubsanar > 0 && (
            <div className="kpi-col-item">
              <div
                className={`kpi-card kpi-card-subsanar kpi-card-clickable ${kpiSeleccionado === "subsanar" ? "kpi-card-selected" : ""}`}
                onClick={() => toggleKpi("subsanar")}
                role="button"
                tabIndex={0}
                title="Filtrar por postulaciones con documentos pendientes por subsanar"
              >
                <div className="kpi-icon-badge">
                  <ExclamationCircleOutlined />
                </div>
                <div className="kpi-value">{countSubsanar}</div>
                <div className="kpi-label">Por subsanar</div>
              </div>
            </div>
          )}

          {/* 3. Por completar (ámbar) — Prioridad 2: borradores por completar */}
          {countCompletar > 0 && (
            <div className="kpi-col-item">
              <div
                className={`kpi-card kpi-card-completar kpi-card-clickable ${kpiSeleccionado === "completar" ? "kpi-card-selected" : ""}`}
                onClick={() => toggleKpi("completar")}
                role="button"
                tabIndex={0}
                title="Filtrar por postulaciones en borrador pendientes por completar"
              >
                <div className="kpi-icon-badge">
                  <EditOutlined />
                </div>
                <div className="kpi-value">{countCompletar}</div>
                <div className="kpi-label">Por completar</div>
              </div>
            </div>
          )}

          {/* 4. No subsanado (rojo) — el plazo de subsanación ya venció */}
          {countNoSubsanado > 0 && (
            <div className="kpi-col-item">
              <div
                className={`kpi-card kpi-card-rechazadas kpi-card-clickable ${kpiSeleccionado === "no_subsanado" ? "kpi-card-selected" : ""}`}
                onClick={() => toggleKpi("no_subsanado")}
                role="button"
                tabIndex={0}
                title="Postulaciones cuyo plazo de subsanación ya venció"
              >
                <div className="kpi-icon-badge">
                  <CloseCircleOutlined />
                </div>
                <div className="kpi-value">{countNoSubsanado}</div>
                <div className="kpi-label">No subsanado</div>
              </div>
            </div>
          )}

          {/* 5. Rechazadas (rojo) — junto a No subsanado */}
          {countRechazadas > 0 && (
            <div className="kpi-col-item">
              <div
                className={`kpi-card kpi-card-rechazadas kpi-card-clickable ${kpiSeleccionado === "rechazadas" ? "kpi-card-selected" : ""}`}
                onClick={() => toggleKpi("rechazadas")}
                role="button"
                tabIndex={0}
                title="Filtrar por postulaciones no seleccionadas o rechazadas"
              >
                <div className="kpi-icon-badge">
                  <CloseCircleOutlined />
                </div>
                <div className="kpi-value">{countRechazadas}</div>
                <div className="kpi-label">Rechazadas</div>
              </div>
            </div>
          )}

          {/* 6. Inscritas (azul) */}
          {countInscritas > 0 && (
            <div className="kpi-col-item">
              <div
                className={`kpi-card kpi-card-inscritas kpi-card-clickable ${kpiSeleccionado === "inscritas" ? "kpi-card-selected" : ""}`}
                onClick={() => toggleKpi("inscritas")}
                role="button"
                tabIndex={0}
                title="Filtrar por postulaciones inscritas exitosamente"
              >
                <div className="kpi-icon-badge">
                  <CheckCircleOutlined />
                </div>
                <div className="kpi-value">{countInscritas}</div>
                <div className="kpi-label">Inscritas</div>
              </div>
            </div>
          )}

          {/* 7. Evaluadas (violeta) */}
          {countEvaluadas > 0 && (
            <div className="kpi-col-item">
              <div
                className={`kpi-card kpi-card-evaluadas kpi-card-clickable ${kpiSeleccionado === "evaluadas" ? "kpi-card-selected" : ""}`}
                onClick={() => toggleKpi("evaluadas")}
                role="button"
                tabIndex={0}
                title="Filtrar por postulaciones evaluadas"
              >
                <div className="kpi-icon-badge">
                  <BarChartOutlined />
                </div>
                <div className="kpi-value">{countEvaluadas}</div>
                <div className="kpi-label">Evaluadas</div>
              </div>
            </div>
          )}

          {/* 8. Beneficiario (verde) — Ganadores / Seleccionados */}
          {countBeneficiario > 0 && (
            <div className="kpi-col-item">
              <div
                className={`kpi-card kpi-card-beneficiario kpi-card-clickable ${kpiSeleccionado === "beneficiario" ? "kpi-card-selected" : ""}`}
                onClick={() => toggleKpi("beneficiario")}
                role="button"
                tabIndex={0}
                title="Filtrar por proyectos beneficiarios / ganadores"
              >
                <div className="kpi-icon-badge">
                  <TrophyOutlined />
                </div>
                <div className="kpi-value">{countBeneficiario}</div>
                <div className="kpi-label">Beneficiario</div>
              </div>
            </div>
          )}

          {/* 9. Anuladas (gris / neutro) */}
          {countAnuladas > 0 && (
            <div className="kpi-col-item">
              <div
                className={`kpi-card kpi-card-anuladas kpi-card-clickable ${kpiSeleccionado === "anuladas" ? "kpi-card-selected" : ""}`}
                onClick={() => toggleKpi("anuladas")}
                role="button"
                tabIndex={0}
                title="Filtrar por postulaciones anuladas"
              >
                <div className="kpi-icon-badge">
                  <StopOutlined />
                </div>
                <div className="kpi-value">{countAnuladas}</div>
                <div className="kpi-label">Anuladas</div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Indicador de filtro activo */}
      {kpiSeleccionado && kpiSeleccionado !== "todas" && (
        <div className="filtro-activo-banner">
          <div className="filtro-activo-info">
            <span className="filtro-activo-label">Filtrando por:</span>
            <span className="filtro-activo-tag">{getKpiLabel(kpiSeleccionado)}</span>
            <span className="filtro-activo-conteo">
              ({datosAMostrar.length} {datosAMostrar.length === 1 ? "postulación" : "postulaciones"})
            </span>
          </div>
          <button
            type="button"
            className="btn-limpiar-filtro-kpi"
            onClick={() => setKpiSeleccionado(null)}
          >
            <span className="btn-close-icon">✕</span>
            <span>Ver todas</span>
          </button>
        </div>
      )}

      {/* Buscador de texto */}
      <div className="row mt-2 mb-3">
        <div className="col-12 col-md-8 col-lg-6">
          <CampoDeBusqueda
            placeholder="Busca por proyecto, línea, categoría o estado"
            alBuscar={buscar}
          />
        </div>
      </div>

      {/* 4. Tabla paginada de postulaciones */}
      <div className="row-shadow2 ms-1 mt-3 mb-4">
        <div className="row">
          <div className="col-12 col-md-6 pb-2 font-size-14px font-family-Montserrat-SemiBold">
            Gestionar postulación de proyectos
          </div>
          <div className="col-12 col-md-6 pb-2">
            <div className="row g-2">
              <div className="col-10 col-md-10 col-xl-10 col-xxl-11 d-flex justify-content-end align-content-center">
                <span className="pe-4 col d-flex justify-content-md-end">
                  Total :{" "}
                  <span className="font-color-F28C02">{datosAMostrar.length}</span>
                </span>
                <span className="d-flex flex-nowrap pt-1 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                  Registros por página
                </span>
              </div>
              <div className="col-2 col-md-2 col-xl-2 col-xxl-1 justify-content-between">
                <Dropdown
                  fluid
                  className="select-registros-adminconvocatoria no-margin"
                  defaultValue={cantidadpáginas}
                  options={cantidadRegistros}
                  icon={<IconFlechareg />}
                  onChange={(e, { value }) => cambiarCantidadPaginas(e, value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12">
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciado datos para esta sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              pagination={{
                position: ["bottomRight"],
                itemRender: itemRenderTable,
                pageSize: cantidadpáginas,
              }}
              columns={columns}
              dataSource={datosAMostrar}
              scroll={{ x: 1500, y: 350 }}
              size="small"
              rowClassName="sizeTable table-row"
              className="table-ant-design-modify"
              bordered={false}
            />
          </div>
        </div>
      </div>
        <ModalVerPropuesta
          modal={modal}
          AceptarModal={() => setModal(false)}
          postulacion={postulacion}
          descargarArchivo={descargarArchivo}
          CancelarModal={() => setModal(false)}
          lineasConvocatoria={lineasconvocatoria}
        />

        <ModalVerPropuestaSubsanar
          modal={modalSubsanar}
          AceptarModal={() => {
            setModalSubsanar(false);
            cargarPostulaciones();
          }}
          postulacion={postulacionSubsanar || initialValuesPostulacionModel}
          setPostulacion={(updated: any) => {
            setPostulacionSubsanar(updated);
            setPostulaciones((prev: any[]) =>
              prev.map((p: any) => (p.id_postulacion === updated.id_postulacion ? updated : p))
            );
          }}
          allpostulaciones={postulaciones}
          setAllPostulaciones={setPostulaciones}
          descargarArchivo={descargarArchivo}
          CancelarModal={() => setModalSubsanar(false)}
          lineasConvocatoria={lineasconvocatoria}
          soloSubsanables={true}
        />

        <Modal
          style={{ top: 60, zIndex: 3, background: "transparent" }}
          visible={isModalOpen}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closeIcon="X"
          onOk={handleOk}
          onCancel={handleCancel}
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa modal-formularios-completar"
        >
          {console.log('postulacionEditar', postulacionEditar)}
          {
            postulacionEditar ?
              <div>
                <div className="row-shadow">
                  <div className="row">
                    <div className="text-center col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_azul">
                      Continua con tu postulación de la convocatoria
                      <br />
                      Radicado: {postulacionEditar.radicado}
                    </div>
                    <div className="text-center p-3 col-12 font-size-16px font-family-Montserrat-SemiBold justify-content-center">
                      Selecciona el paso en el que deseas continuar tú postulación
                    </div>
                  </div>
                  <div className="row border-top mt-4 justify-content-flex-center">
                    <div className="col-6 justify-content-flex-start">
                      {/* <Button
                    className="button-azul-radius mb-0"
                    onClick={AceptarModal}
                  >
                    ACEPTAR
                  </Button> */}
                    </div>
                  </div>
                  <div id="printThis" className="row-shadow mt-2">
                    <div className="row">
                      <div className="col-12 border-bottom font-family-Montserrat-Regular font-size-14px pb-3">
                        Formularios completados
                      </div>
                    </div>
                    <div className="row p-3" style={{ maxHeight: "420px", overflowY: "auto" }}>

                      {estadoDeLosPasos(postulacionEditar.pasos).map((paso) => (
                        <div
                          key={paso.clave}
                          className="col-12 d-flex flex-wrap align-items-start justify-content-between py-3 border-bottom"
                        >
                          <div className="pe-3" style={{ minWidth: "55%", flex: "1 1 55%" }}>
                            <div className="font-family-Montserrat-SemiBold font-size-14px mb-2">
                              {paso.numero}. {paso.titulo}
                            </div>
                            {/* Lo que recoge el paso: se ve de una que falta. */}
                            <ul className="list-unstyled mb-0">
                              {paso.partes.map((parte) => (
                                <li
                                  key={parte.etiqueta}
                                  className="font-family-Montserrat-Regular font-size-12px mb-1 d-flex align-items-center"
                                >
                                  {parte.completo ? (
                                    <CheckCircleOutlined className="font-color-00904C font-size-14px me-2" />
                                  ) : (
                                    <CloseCircleOutlined className="font-color-DB2828 font-size-14px me-2" />
                                  )}
                                  <span className={parte.completo ? "" : "font-color-707070"}>
                                    {parte.etiqueta}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="d-flex align-items-center" style={{ gap: 16 }}>
                            <span className="font-family-Montserrat-Regular font-size-12px text-nowrap">
                              {paso.completo ? (
                                <>
                                  <CheckCircleOutlined className="font-color-00904C font-size-16px me-2" />
                                  Completado
                                </>
                              ) : (
                                <>
                                  <InfoCircleOutlined className="texto_azul font-size-16px me-2" />
                                  Incompleto
                                </>
                              )}
                            </span>
                            <button
                              type="button"
                              onClick={() => navigate(rutaDelPaso(paso.clave))}
                              className="button-blanco-radius font-family-Montserrat-SemiBold font-size-12px text-nowrap"
                              style={{ margin: 0, padding: "6px 18px", cursor: "pointer" }}
                            >
                              <EditOutlined className="font-color-F28C02 font-size-14px me-2" />
                              Continuar
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              :
              <p>No se pudo cargar esta convocatoria</p>
          }
        </Modal>

        <Modal
          style={{ top: 120, zIndex: 3, background: "transparent" }}
          visible={isModalOpen2}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closeIcon="X"
          onOk={handleOk2}
          onCancel={handleCancel2}
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa modal-formularios-completar"
        >
          {
            postulacionEditar ?
              <div>
                <div className="row-shadow">
                  <div className="row">
                    <div className="text-center col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_azul">
                      ¿Desea anular la postulación con radicado: {postulacionEditar.radicado}?
                    </div>
                    <div className="text-center col-12">
                      <Button className="button-gray-ghost" onClick={handleCancel2}>
                        CANCELAR
                      </Button>
                      <Button className="button-azul-radius" onClick={() => {
                        guardar(postulacionEditar);
                        handleOk2();
                      }}>
                        ACEPTAR
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              :
              <p>No se pudo cargar esta convocatoria</p>
          }
        </Modal>
        <ModalAvisoInfo
          visualizar={avisoInfo}
          setVisualizar={setAvisoInfo}
        />
        {verMasOpen && datosEvaluacion && (
          <VerMasProyectos
            openModal={verMasOpen}
            setOpenModal={setVerMasOpen}
            datos={datosEvaluacion}
          />
        )}
    </div>
  );
};
